import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function TruthSection() {
  const painPoints = ['Consejos genéricos que no aplican a tu situación', 'Estrategias desconectadas entre sí', 'Más información de la que puedes procesar', 'Y cero sistema para ejecutar'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950" data-id="element-148">
      <div className="max-w-4xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-150">
          <h2 className="text-3xl sm:text-4xl font-bold mb-6 text-white" data-id="element-151">
            La Verdad Que <span className="text-gold-400" data-id="element-152">Nadie Te Dice</span>
          </h2>
        </motion.div>

        <div className="prose prose-lg prose-invert mx-auto" data-id="element-153">
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="text-xl text-slate-300 leading-relaxed mb-6" data-id="element-154">
            Cada día, miles de personas se unen al mundo del marketing de
            afiliados con los ojos llenos de posibilidades. Ven los testimonios.
            Ven los screenshots de comisiones. Ven a influencers hablar de
            «ingresos pasivos» mientras viajan por el mundo.
          </motion.p>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="text-xl text-slate-300 leading-relaxed mb-8" data-id="element-155">
            Y piensan:{' '}
            <span className="italic text-white" data-id="element-156">
              «Yo también puedo hacer eso.»
            </span>{' '}
            Y tienen razón.{' '}
            <strong className="text-gold-400 font-bold" data-id="element-157">Pueden.</strong> El
            problema es que nadie les dice cómo hacerlo en realidad.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="bg-navy-900/50 border border-red-900/30 rounded-2xl p-8 mb-10" data-id="element-158">
            <p className="text-lg font-medium text-white mb-6" data-id="element-159">
              En cambio, reciben:
            </p>
            <ul className="space-y-4" data-id="element-160">
              {painPoints.map((point, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5 + index * 0.1,
              duration: 0.5
            }} className="flex items-start space-x-3" data-id="element-161">
                  <XCircle className="w-6 h-6 text-red-500/80 flex-shrink-0 mt-0.5" data-id="element-162" />
                  <span className="text-slate-300" data-id="element-163">{point}</span>
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.8,
          duration: 0.8
        }} className="text-xl text-slate-300 leading-relaxed" data-id="element-164">
            El resultado es predecible:{' '}
            <strong className="text-white font-medium" data-id="element-165">
              meses de esfuerzo sin resultados.
            </strong>{' '}
            Y eso genera algo peor que la falta de ingresos — genera duda. La
            duda de que quizás el marketing digital es solo para unos pocos
            elegidos.
          </motion.p>
        </div>
      </div>
    </section>;
}